module.exports = __webpack_public_path__ + "../resources/img/complate_bg.ddc0d204.png";